import { createRouter, createWebHashHistory } from "vue-router";
import DashboardGeneral from "../components/dashboard/DashboardGeneral.vue";
import DashboardIndex from "../components/dashboard/index.vue";
import LoginDash from "../components/LoginDash.vue";
import ClientesDashboard from "../components/dashboard/Clientes.vue";
import PortalSeguimiento from "../components/dashboard/PortalSeguimiento.vue";
import Acceso from "../components/Acceso.vue";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: LoginDash,
    meta: { requiresGuest: true }
  },
  // Sección de entrada de la app: es la que abre tras el login.
  {
    path: "/",
    name: "Dashboard",
    component: DashboardGeneral,
    meta: { requiresAuth: true },
  },
  {
    path: "/encuestas",
    name: "Encuestas",
    component: DashboardIndex,
    meta: { requiresAuth: true },
  },
  {
    path: "/clientes",
    name: "ClientesDashboard",
    component: ClientesDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/portal",
    name: "PortalSeguimiento",
    component: PortalSeguimiento,
    meta: { requiresAuth: true },
  },
  {
    path: "/acceso",
    name: "Acceso",
    component: Acceso,
    meta: { requiresAuth: true },
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
// 🔒 Middleware para proteger rutas
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");

  if (to.meta.requiresAuth && !token) {
    // necesita login pero no hay token
    next("/login");
  } else if (to.meta.requiresGuest && token) {
    // ya tiene token, no debe ir a login ni home
    next("/");
  } else {
    next();
  }
});

// Las vistas de página las registra el SDK por sí solo (rutas hash incluidas,
// ver public/sdk/telemetry.js): un track("page_view") aquí las duplicaría.
export default router;
